import axios, { AxiosInstance, AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { localVariables } from '../utils/Constant';

const baseURL: string = `${process.env.REACT_APP_HOST_IP}/api` || 'http://localhost:8000';

const apiClient: AxiosInstance = axios.create({
    baseURL: baseURL
});

apiClient.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const token: string | null = localStorage.getItem(localVariables.ACCESSTOKEN);

        if (!(config.data instanceof FormData)) {
            config.headers['Content-Type'] = 'application/json';
        }
        config.headers['ngrok-skip-browser-warning'] = 'true';

        if (token) config.headers.Authorization = `Bearer ${token}`;

        return config;
    },
    (error: AxiosError) => Promise.reject(error)
);

apiClient.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => Promise.reject(error)
);

export default apiClient;
